<template>
    <div >
        <div class="mobile-page" :class=" configData.bgStyle.type == 0 ?'':'pageOn'"
             :style="{padding:'0 '+ configData.prConfig.val +'px', marginTop: configData.mbConfig.val + 'px', background: configData.themeColor.color[0].item}">
            <div class="home_product">
                <!-- 单列 -->
                <div class="list-box" v-if="list.length > 0">
                    <div class="list" v-for="(res, index) in list"
                         :key="index + ''">
                        <img class="item-image" :src="res.image" mode="aspectFill"/>
                        <div class="item-bottom">
                            <div class="item-title">
                                {{res.name}}
                            </div>
                            <div class="pirce" v-if="res.price_min>9999">
                                <span>￥{{res.price_min}} <span class="text-sm text-through text-gray"
                                                               v-if="res.market_price_min">￥{{Number(res.market_price_min)}}</span></span>
                                <img class="buyicon" src="@/assets/images/ic11.png"/>
                            </div>
                            <div class="pirce" v-else>
                                <span>￥{{res.price_min}} <span class="text-sm text-through text-gray"
                                                               v-if="res.market_price_min">￥{{res.market_price_min}}</span></span>
                                    <img class="buyicon" src="@/assets/images/ic11.png"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-box" v-else>
                    <div class="list" v-for="(res, index) in list" :key="index">
                        <div class="item-image">
                            <div class="empty-box"><span class="iconfont icontupian"></span></div>
                        </div>
                        <div class="item-bottom">
                            <div class="item-title">
                                {{res.name}}
                            </div>
                            <div class="pirce" v-if="res.price_min>9999">
                                <span>￥{{res.price_min}} <span class="text-sm text-through text-gray"
                                                               v-if="res.market_price_min">￥{{Number(res.market_price_min)}}</span></span>
                                <img class="buyicon" src="@/assets/images/ic11.png"/>
                            </div>
                            <div class="pirce" v-else>
                                <span>￥{{res.price_min}} <span class="text-sm text-through text-gray"
                                                               v-if="res.market_price_min">￥{{res.market_price_min}}</span></span>
                                <img class="buyicon" src="@/assets/images/ic11.png"/>
                            </div>
                        </div>
                    </div>
                    <div class="list" v-for="(item, index) in configData.numConfig.val" :key="index">
                        <div class="item-image">
                            <div class="empty-box"><span class="iconfont icontupian"></span></div>
                        </div>
                        <div class="item-bottom">
                            <div class="item-title">
                                商品标题
                            </div>
                            <div class="pirce">
                                <span>￥99<span class="text-sm text-through text-gray">￥125</span></span>
                                <img class="buyicon" src="@/assets/images/ic11.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "goodsList",
        sort: 100,
        cname: '商品列表',
        type: 0, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconcuxiaoliebiao1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        watch: {
            configData: {
                handler(nVal, oVal) {
                    this.setConfig(nVal)
                },
                immediate: true,
                deep: true
            }
        },
        data() {
            return {
                list: [],
                defaultConfig: {
                    name: "goodsList",
                    cname: '商品列表',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        tabConfig: {
                            tab: 0,
                            name: 'tab',
                            title: '选择模板',
                            type: 0,
                            tabList: [
                                {
                                    name: '自动选择',
                                    icon: 'iconzidongxuanze'
                                },
                                {
                                    name: '手动选择',
                                    icon: 'iconshoudongxuanze'
                                }
                            ]
                        },
                        selectConfig: {
                            tab: 0,
                            name: 'category',
                            title: '商品分类',
                            activeValue: '',
                            list: [
                                {
                                    activeValue: '',
                                    title: ''
                                },
                                {
                                    activeValue: '',
                                    title: ''
                                }
                            ]
                        },
                        numConfig: {
                            tab: 0,
                            name: 'inputnumber',
                            min: 1,
                            val: 3
                        },
                        goodsList: {
                            tab: 0,
                            name: 'goodslist',
                            max: 20,
                            list: []
                        },
                        themeColor: {
                            title: '背景颜色',
                            name: 'colors',
                            tab: 1,
                            default: [{
                                item: '#f8f8f8'
                            }],
                            color: [
                                {
                                    item: '#f8f8f8'
                                }
                            ]
                        },
                        bgStyle: {
                            title: '背景样式',
                            name: 'radio',
                            type: 0,
                            tab: 1,
                            list: [
                                {
                                    val: '直角',
                                    icon: 'iconPic_square'
                                },
                                {
                                    val: '圆角',
                                    icon: 'iconPic_fillet'
                                }
                            ]
                        },
                        conStyle: {
                            title: '内容样式',
                            name: 'radio',
                            type: 1,
                            tab: 1,
                            list: [
                                {
                                    val: '直角',
                                    icon: 'iconPic_square'
                                },
                                {
                                    val: '圆角',
                                    icon: 'iconPic_fillet'
                                }
                            ]
                        },
                        prConfig: {
                            name: 'slider',
                            title: '背景边距',
                            val: 10,
                            tab: 1,
                            min: 0
                        },
                        mbConfig: {
                            name: 'slider',
                            title: '页面间距',
                            val: 0,
                            tab: 1,
                            min: 0
                        },
                    }
                }
            }
        },
        mounted() {

        },
        methods: {
            setConfig: function (data) {
                console.log(data.tabConfig.type)
                console.log(data)
                if (data.tabConfig.type) {
                    this.list = data.goodsList.list || []
                } else {
                    this.list = []
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .itemOn {
        border-radius: 0 !important;

        img, .empty-box {
            border-radius: 0 !important;
        }

        .img-box {
            .label {
                border-radius: 0 0 8px 0 !important;
            }
        }
    }

    .pageOn {
        border-radius: 8px !important
    }

    .paddingBox {
        padding-bottom: 0;
    }

    .list-box {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .list-box .list {
        width: 48.5%;
        margin-bottom: 27px;
    }

    .list .item-image {
        width: 100%;
        height: 166.5px;
        border-radius: 3.5px 3.5px 0 0;
        background: #FFFFFF;
    }

    .list .item-bottom {
        width: 100%;
        height: 71.5px;
        padding-left: 10px;
        padding-right: 10px;
        box-sizing: border-box;
        background-color: #FFFFFF;
        border-radius: 0 0 3.5px 3.5px;
    }

    .item-bottom .pirce {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #FF0103;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
    }

    .item-bottom .pirce img {
        width: 17.5px;
        height: 17.5px;
    }

    .item-bottom .item-title {
        width: 100%;
        font-size: 14px;
        height: 48px;
        line-height: 24px;
        color: #1C1C1C;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
